import { size } from 'lodash-es';
import type { SizeOfExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const sizeResolver =
  createSimpleNamedExpressionResolver<SizeOfExpression>('size', size);
